import {createSlice} from '@reduxjs/toolkit'

export const cardManualSlice=createSlice({
    name:"cardManualSlice",
    initialState:{
        value:undefined
    },
    reducers:{
        get_card_manual:(state,action)=>{
            state.value=action.payload.cardManualData
        }
    }
})
export const {get_card_manual} = cardManualSlice.actions

export default cardManualSlice.reducer